// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__4fHoP","shake":"FloatingButton_shake__-P+em"};